import { LanguageList } from "@/models/LanguageList"

export function getLanguageString(index: keyof typeof LanguageList) {
  return LanguageList[index]
}
